import * as Sentry from '@sentry/react';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { authSkipRoutes } from './authSkipRoutes';
import { protectedRoutes } from './protected';
import { publicRoutes } from './public';
import { GetStarted } from '@/components/GetStarted';
import Loader from '@/components/Loader';
import { OfflineContainer } from '@/containers/OfflineContainer';
import { useUser } from '@/lib/auth';
import { LoginWithMobileOTP } from '@/modules/auth/pages/LoginWithMobileOTP';
import storage from '@/utils/storage';

type AppRoutesProps = {
  configData: any;
};

export const AppRoutes = ({ configData }: AppRoutesProps) => {
  const config = configData ?? storage.getItem('config');

  const IS_SERVER_OFFLINE = storage.getItem('IS_SERVER_OFFLINE');
  const IS_NO_INTERNET = storage.getItem('IS_NO_INTERNET');

  const commonRoutes = config?.otp_login
    ? [{ path: '/auth/login-with-mobile-otp', element: <LoginWithMobileOTP /> }]
    : [{ path: '/get-started', element: <GetStarted /> }];

  const { data, isInitialLoading } = useUser();

  if (isInitialLoading) {
    return <Loader />;
  }
  if (IS_SERVER_OFFLINE || (IS_NO_INTERNET && !data)) {
    return <OfflineContainer showOfflinePopup isPrelogin />;
  }

  const configRoutes = config?.auth_skip
    ? [...authSkipRoutes(config), ...publicRoutes(config)]
    : publicRoutes(config);

  const routes = data ? protectedRoutes : [...configRoutes, ...commonRoutes];
  const sentryCreateBrowserRouter = Sentry.wrapCreateBrowserRouter(createBrowserRouter);

  const router = sentryCreateBrowserRouter([...routes]);

  return <RouterProvider router={router} />;
};
